import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import EquipmentCategoryService from "@services/EquipmentCategoryService";

const ShowEquipmentCategory = ({ equipmentCategory }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [equipmentCategoryData, setEquipmentCategoryData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      EquipmentCategoryService.find(equipmentCategory.id).then((response) => {
        setEquipmentCategoryData(response.data.data);
      });
  }, [equipmentCategory.id, showModal]);

  return (
    <PermissionHandler permission={"view_equipment_categories"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={equipmentCategoryData.name} />
          <RowDetails
            label={t("nameEng")}
            value={equipmentCategoryData.name_eng}
          />
          <RowDetails
            label={t("description")}
            value={equipmentCategoryData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowEquipmentCategory;
